<template>
  <div>
    <div class="section-right-content-box">
      <div class="box-shadow top-box">
        <div class="global-title">
          客户消费分析
        </div>
      </div>
      <div style="padding: 28px;">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="会员消费分析" name="0"></el-tab-pane>
          <el-tab-pane label="地域分析" name="1"></el-tab-pane>
          <el-tab-pane label="金额分析" name="2"></el-tab-pane>
          <el-tab-pane label="月度报表" name="3"></el-tab-pane>
        </el-tabs>
        <div>
          <PeopleLevel v-if="activeName == 0" />
          <RegionalAnalysis v-if="activeName == 1" />
          <AmountAnalysis v-if="activeName == 2" />
          <MonthlyReport v-if="activeName == 3" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import PeopleLevel from "./people_level.vue"
import RegionalAnalysis from "./regional_analysis.vue"
import AmountAnalysis from "./amount_analysis.vue"
import MonthlyReport from "./monthly_report.vue"
export default {
  data() {
    return {
      tabsMenu: [
        {
          name: "people",
          title: "会员消费分析"
        },
        {
          name: "regional",
          title: "地域分析"
        },
        {
          name: "amount",
          title: "金额分析"
        },
        {
          name: "monthly",
          title: "月度报表"
        },
      ],
      activeName: "0",
    };
  },
  created() {
    // 埋点
    this.buriedPoint(1, '客户消费分析', '数据分析', '客户分析')
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },

  components: {
    PeopleLevel,
    RegionalAnalysis,
    AmountAnalysis,
    MonthlyReport,
  },

  methods: {
    handleClick(item) {
      this.activeName = item.name
    }
  },
};
</script>

<style lang="scss" scoped>
.section-right-content-box {
  min-width: 1046px;
  margin-top: 10px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  margin: 10px 20px 20px 20px;

  .tabs {
    margin-bottom: 26px;

    .tabItem {
      margin-right: 1px;
      padding: 8px 11px;
      border: 1px solid #bbb;
      cursor: pointer;
    }

    .activityItem {
      color: red;
      background-color: #ccc;
    }
  }
}
</style>
